export default __webpack_public_path__ + "static/media/npm.bf117b29.png";